import { ConnectionState } from 'livekit-client'
import type { Participant } from 'livekit-client'

interface SettingsPanelProps {
  description: string
  roomInfo: { name?: string }
  localParticipant: Participant
  connectionState: ConnectionState
}

export function SettingsPanel({
  description,
  roomInfo,
  localParticipant,
  connectionState,
}: SettingsPanelProps) {
  return (
    <div className="flex flex-col gap-6 h-full w-full items-start overflow-y-auto p-4">
      {/* Description */}
      <div className="w-full">
        <h3 className="text-sm font-semibold text-foreground mb-2">
          Description
        </h3>
        <p className="text-xs text-muted-foreground leading-relaxed">
          {description}
        </p>
      </div>

      {/* Settings */}
      <div className="w-full">
        <h3 className="text-sm font-semibold text-foreground mb-3">Settings</h3>
        <div className="flex flex-col gap-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Room</span>
            <span className="text-sm text-foreground font-medium">
              {roomInfo.name}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Participant</span>
            <span className="text-sm text-foreground font-medium">
              {localParticipant.identity}
            </span>
          </div>
        </div>
      </div>

      {/* Status */}
      <div className="w-full">
        <h3 className="text-sm font-semibold text-foreground mb-3">Status</h3>
        <div className="flex justify-between items-center">
          <span className="text-sm text-muted-foreground">Connection</span>
          <span className="text-sm text-foreground font-medium uppercase">
            {connectionState}
          </span>
        </div>
      </div>
    </div>
  )
}
